import React, { useEffect, useState } from "react";
import { GridColumn, Icon, Step } from 'semantic-ui-react';

import { Outlet, useLocation } from "react-router-dom";


export default function CartPage() {

  const [activeStep, setStep] = useState(1)
  const location = useLocation()

  useEffect(() => {
    switch(location.pathname){
      case "/cart": setStep(1); break;
      case "/cart/delivery": setStep(2); break;
      case "/cart/payment": setStep(3); break;
      default: break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return(
    <React.Fragment>
      <GridColumn computer={10} tablet={16}>

        <Step.Group fluid widths={3}>
          <Step active={activeStep === 1} completed={activeStep > 1} link href="/cart">
            <Icon name="cart"/>
            <Step.Content>
              <Step.Title>Cart</Step.Title>
              <Step.Description>This is your order</Step.Description>
            </Step.Content>
          </Step>
          <Step active={activeStep === 2} completed={activeStep > 2} link href="/cart/delivery">
            <Icon name="truck"/>
            <Step.Content>
              <Step.Title>Delivery</Step.Title>
              <Step.Description>Choose your shipping options</Step.Description>
            </Step.Content>
          </Step>
          <Step  active={activeStep === 3} completed={activeStep > 3} link href="/cart/payment">
            <Icon name="credit card"/>
            <Step.Content>
              <Step.Title>Payment</Step.Title>
              <Step.Description>Enter billing information</Step.Description>
            </Step.Content>
          </Step>                    
        </Step.Group>

        <Outlet/>
      </GridColumn>
    </React.Fragment>
  )
}